import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";

const PropertyImageSelection = ({ show, onClose, onSelection, images = [], multiple = false }) => {

  const [selected, setSelected] = useState(multiple ? [] : null);
  const [dimensions, setDimensions] = useState({});

  const handleSelect = (url) => {
    if (multiple) {
      let updated;
      if (selected.includes(url)) {
        updated = selected.filter((item) => item !== url);
      } else {
        updated = [...selected, url];
      }
      setSelected(updated);;
    } else {
      setSelected(url);
    }
  };

  const handleImageLoad = (e, url) => {
    const { naturalWidth, naturalHeight } = e.target;
    setDimensions((prev) => ({
      ...prev,
      [url]: `${naturalWidth} x ${naturalHeight}`,
    }));
  };

  return (
    <Modal show={show} onHide={onClose} bsSize={'lg'}>
      <Modal.Header closeButton className="theme-bg">
        <Modal.Title>Final Listing Images</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{
        overflow: 'auto',
        maxHeight: '70vh'
      }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
          {images.map((url, index) => (
            <div
              key={index}
              style={{
                position: "relative",
                border: multiple
                  ? selected.includes(url)
                    ? "2px solid #007bff"
                    : "0px solid #ddd"
                  : selected === url
                  ? "2px solid #007bff"
                  : "0px solid #ddd",
                borderRadius: "4px",
                cursor: "pointer",
                textAlign: "center"
              }}
              onClick={() => handleSelect(url)}
            >
              <div>
                <img
                  src={url}
                  alt={`aws-img-${index}`}
                  style={{
                    width: "200px",
                    height: "200px",
                    objectFit: "cover",
                    borderRadius: "4px"
                  }}
                  onLoad={(e) => handleImageLoad(e, url)}
                />

                <div style={{ fontSize: "12px", marginTop: "4px", color: "#555" }}>
                  {dimensions[url] || "Loading..."}
                </div>

                <input
                  style={{
                    position: 'absolute',
                    left: '3px',
                    top: '0px'
                  }}
                  type={multiple ? "checkbox" : "radio"}
                  checked={multiple ? selected.includes(url) : selected === url}
                  readOnly
                />
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button className="btn btn-default" onClick={onClose}>
          Cancel
        </Button>
        <Button className="btn red-mint" onClick={() => onSelection(selected)}>
          Done {multiple ? selected?.length: ''}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PropertyImageSelection;
